import CancelIcon from '@/components/icons/CancelIcon';
import SearchIcon from '@/components/icons/SearchIcon';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { t } from 'i18next';
import { FC } from 'react';

type Props = {
  value: string;
  onChange: (e: string) => void;
}

const CalendarSearch: FC<Props> = ({value, onChange}) => {
	return (
		<div className='relative h-[68px] p-6 py-4 flex items-start flex-col'>
			<Input
				className='px-0 pr-9 border-none focus:border-none focus-visible:ring-0 focus:shadow-none'
				placeholder={t('main.calendar.components.search.placeholder')}
				value={value}
				onChange={(e) => onChange(e.target.value)}
			/>
			{value ? (
				<Button
					variant='link'
					type='submit'
					className='absolute right-6 top-1/2 -translate-y-1/2 h-fit p-0'
					onClick={() => onChange('')}>
					<CancelIcon />
				</Button>
			) : (
				<Button
					variant='link'
					type='submit'
					className={
						'absolute right-6 top-1/2 -translate-y-1/2 h-fit p-0'
					}>
					<SearchIcon />
				</Button>
			)}
		</div>
	);
};

export default CalendarSearch;
